"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var __1 = require("..");

var baseWallet = function () {
  function baseWallet() {}

  baseWallet.prototype.getBalance = function (address) {
    return __1.getBalance(address);
  };

  baseWallet.NeedUnlockWalletError = new Error("Need Unlock Wallet");
  baseWallet.NotSupportedError = new Error("Current Wallet Not Supported");
  return baseWallet;
}();

exports.default = baseWallet;